import React from 'react';
import { useAlertUiTranslation } from '../../../../hooks';
import { NotificationContentSectionWrapper } from '../NotificationContentSectionWrapper';
import { NotificationAttachmentListItem } from './NotificationAttachmentListItem';
export const NotificationAttachmentList = ({ notificationId, attachments }) => {
    const { t } = useAlertUiTranslation();
    if (!attachments.length) {
        return null;
    }
    return (React.createElement(NotificationContentSectionWrapper, { heading: t('common.attachment') }, attachments.map((attachment) => (React.createElement(NotificationAttachmentListItem, { key: attachment.name, notificationId: notificationId, attachment: attachment })))));
};
